import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Moon, Sun } from "lucide-react";

export default function Header({ theme, toggleTheme }) {
  const [open, setOpen] = useState(false);

  const handleLinkClick = () => {
    setOpen(false);
    window.scrollTo(0, 0);
  };

  // Close mobile menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo" onClick={handleLinkClick}>
          <span>I</span>.Mrakpor
        </Link>

        <nav className="nav-desktop">
          <Link to="/">Home</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/services">Services</Link>
          <Link to="/contact">Contact</Link>
          <button className="icon-btn" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>
        </nav>

        <div className="mobile-controls">
          <button className="icon-btn" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>
          
          {/* This button toggles the menu - it shows Menu icon when closed, X icon when open */}
          <button className="icon-btn" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile menu - Remove the separate close button since we already have one in mobile-controls */}
        <nav className={`nav-mobile ${open ? "active" : ""}`}>
          <Link to="/" onClick={handleLinkClick}>Home</Link>
          <Link to="/projects" onClick={handleLinkClick}>Projects</Link>
           <Link to="/services" onClick={handleLinkClick}>Services</Link>
          <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
         
        </nav>
      </div>
    </header>
  );
}